import type { UserId } from '@/schemas/ids';
import { downloadRemotePlayerGroups } from './download';
import { mergeRemotePlayerGroups } from './merge';
import { uploadPendingPlayerGroups } from './upload';

export interface SyncPlayerGroupsResult {
  uploadedCount: number;
  downloadedCount: number;
}

export class PlayerGroupsSyncError extends Error {
  constructor(
    message: string,
    public readonly userId: UserId,
    public readonly type: 'upload' | 'download' | 'full',
    public readonly originalError: unknown,
  ) {
    super(message);
    this.name = 'PlayerGroupsSyncError';
  }
}

export async function syncPlayerGroups(userId: UserId): Promise<SyncPlayerGroupsResult> {
  try {
    const up = await uploadPendingPlayerGroups(userId);
    const down = await downloadRemotePlayerGroups(userId);
    await mergeRemotePlayerGroups(down.groups);
    return { uploadedCount: up.uploaded, downloadedCount: down.groups.length };
  } catch (error) {
    throw new PlayerGroupsSyncError(
      error instanceof Error ? error.message : 'Player groups sync failed',
      userId,
      'full',
      error,
    );
  }
}
